var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"disabled":_vm.isDisabled,"items":_vm.branchOfficeList,"label":_vm.branchLabel},on:{"change":_vm.branchChange},model:{value:(_vm.idBranchOffice),callback:function ($$v) {_vm.idBranchOffice=$$v},expression:"idBranchOffice"}})
}
var staticRenderFns = []

export { render, staticRenderFns }